import { GATED_MARKER_LABEL, GATED_MARKER_TITLE } from '../utils/gatedMarker';

/**
 * The `($)` paywall marker rendered after a story title, the way
 * `<MediaKindMarker>` renders (YouTube)/(PDF). Renders nothing for rows that
 * aren't gated. The marker text lives in `utils/gatedMarker.ts`.
 */
export function GatedMarker({ isGated }: { isGated?: boolean | null }) {
  if (!isGated) return null;
  return <span className="gated-marker" title={GATED_MARKER_TITLE}> {GATED_MARKER_LABEL}</span>;
}
